export default class CDPSender {
  constructor(cdp) {
    this.cdp = void 0;
    this.cdp = cdp;
  }
  updateCDP(cdp) {
    this.cdp = cdp;
  }
  send(payload, acknowledge) {
    const handledLogKeys = [];
    payload.forEach(payloadElement => {
      this.cdp.logEvent(payloadElement);
      handledLogKeys.push(payloadElement.uid);
    });
    acknowledge(handledLogKeys);
  }
}
//# sourceMappingURL=index.js.map